import React, { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Statusbar from "../body_root/statusbar";
import { Toast } from "../components_root/ToastContext";
import { MdAdd } from "react-icons/md";
import Cookies from "js-cookie";
import { Save_phonebook_edit } from "./save_phonebook_edit.js";
import CountryCodeSelect from "../body_root/CountryCodeSelect";

export const seo = {
  title: "Free Online Phonebook | Manage Personal Contacts Easily - Viabig",
  description:
    "Create and manage your personal phonebook online for free with Viabig. Add, edit, and organize contacts with categories, mobile numbers, and more. Simple, secure, and easy to use.",
  keywords:
    "free phonebook, online phonebook, manage contacts online, personal phonebook, free contact manager, digital phonebook, viabig phonebook",
  url: "https://viabig.com/phonebook",
  image: "https://viabig.com/assets/logo.png",
};

export default function Phonebook_edit() {
  const location = useLocation();
  const [uid, setUid] = useState("");
  const { Toastshow } = Toast();
  const navigate = useNavigate();

  // form states
  const [category, setCategory] = useState("");
  const [name, setName] = useState("");
  const [countrycode, setCountryCode] = useState("+91");
  const [mobilenumber, setMobileNumber] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [reference_number, setReferenceNumber] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [emailid, setEmailid] = useState("");
  const [website, setWebsite] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // 🔹 Get uid from query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uId = params.get("uid");
    if (uId) setUid(uId);
  }, [location]);

  // 🔹 Fetch phonebook data
  const fetchPhonebook = async () => {
    if (!uid) return;
    setIsLoading(true);
    try {
      const phonebookQuery = query(
        collection(db, "phonebook"),
        where("uid", "==", uid),
        where("guid", "==", Cookies.get("guid"))
      );

      const snapshot = await getDocs(phonebookQuery);

      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        const docData = docSnap.data();
        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
        let child = {};
        fieldsSnap.forEach((fieldDoc) => {
          const { fieldName, fieldValue } = fieldDoc.data();
          child[fieldName] = fieldValue;
        });

        // hydrate state
        setCategory(docData.category || "");
        setName(child.name || "");
        setEmailid(child.emailid || "");
        setWebsite(child.website || "");
        setCountryCode(child.countrycode || "+91");
        setMobileNumber(child.mobilenumber || "");
        setPhoneNumber(child.phonenumber || "");
        setReferenceNumber(child.reference_number || "");
        setAddress(child.address || "");
        setCity(child.city || "");
        setState(child.state || "");
        setCountry(child.country || "");
      }
    } catch (err) {
      console.error("Error fetching phonebook:", err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPhonebook();
  }, [uid]);

  // 🔹 Save phonebook edit
  const post_phonebook_edit = async () => {
    if (!category.trim()) return Toastshow("Please select a category");
    if (!name.trim()) return Toastshow("Please enter a name");
    if (!mobilenumber.trim()) return Toastshow("Please enter mobile number");

    try {
      const result = await Save_phonebook_edit({
        uid,
        name,
        emailid,
        website,
        countrycode,
        category,
        mobilenumber,
        phonenumber,
        reference_number,
        address,
        city,
        state,
        country,
      });

      if (result.success) {
        Toastshow("Contact updated successfully!");
        navigate("/phonebook"); // go back to list if needed
      } else {
        Toastshow("Error: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error("❌ Error submitting post:", error);
      Toastshow("Error submitting post: " + error.message);
    }
  };

  return (
    <div>
      <Statusbar data="Edit Contact" />
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
      </Helmet>

      <div className="container_roots">
        <div className="container_size_mobile">
          <div className="ui-grid-fill">
            <div className="ui-items items-back">
              <div className="rounded border p-1 m-1">
                <label className="text-h2 bold">Category</label>
                <input
                  className="fcap text-h2 border-none bold"
                  placeholder="Category *"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>

              <div className="rounded border p-1 m-1">
                <label className="text-h2 bold">Name</label>
                <input
                  className="fcap text-h2 bold border-none"
                  placeholder="Name *"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="rounded border p-1 m-1">
                <label className="text-h2 bold">Mobile</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <CountryCodeSelect
                    value={countrycode}
                    onChange={setCountryCode}
                  />
                  <input
                    className="text-h2 bold border-none"
                    maxLength={12}
                    placeholder="Mobile number *"
                    value={mobilenumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  />
                </div>

              </div>

              {showMore && (
                <>
                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">Phone</label>
                    <input
                      className="text-h2 bold border-none"
                      maxLength={12}
                      placeholder="Phone number"
                      value={phonenumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </div>
                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">Email</label>

                    <input
                      className="text-h2 bold border-none"
                      maxLength={200}
                      placeholder="Enter Email"
                      value={emailid}
                      onChange={(e) => setEmailid(e.target.value)}
                    />

                  </div>
                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">Website</label>

                    <input
                      className="text-h2 bold border-none"
                      maxLength={200}
                      placeholder="Enter website"
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                    />

                  </div>
                </>
              )}

              <div className="rounded border p-1 m-1">
                <label className="text-h2 bold">R/F/H/No</label>
                <input
                  className="text-h2 border-none"
                  maxLength={15}
                  placeholder="Reference Number"
                  value={reference_number}
                  onChange={(e) => setReferenceNumber(e.target.value)}
                />
              </div>

              <div className="rounded border p-1 m-1">
                <label className="text-h2 bold">Address</label>
                <textarea
                  className="text-h2 border-none"
                  maxLength={120}
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              {showMore && (
                <>

                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">City</label>
                    <input
                      className="text-h2 border-none"
                      maxLength={120}
                      placeholder="City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>

                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">State</label>
                    <input
                      className="text-h2 border-none"
                      maxLength={120}
                      placeholder="State"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>

                  <div className="rounded border p-1 m-1">
                    <label className="text-h2 bold">Country</label>
                    <input
                      className="text-h2 border-none"
                      maxLength={120}
                      placeholder="Country"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>
                </>
              )}

              {!showMore && (
                <div
                  className="center cursor"
                  onClick={() => setShowMore(true)}
                >
                  More
                </div>
              )}

              <div className="button-ui fill" onClick={post_phonebook_edit}>
                <MdAdd className="icon" /> Save
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
